module.exports = __webpack_public_path__ + "static/media/expand.11a5bee7.svg";